// TODO: Get some of GPT to explain ts bro idek 

import React, { useMemo, useState } from "react";
import { alphabetize } from "../../utils/alphabetize";

const GridLayout = ({data}) => {
  const [query, setQuery] = useState("");
  const [industry, setIndustry] = useState(null);
  const [city, setCity] = useState(null);
  const [completeOnly, setCompleteOnly] = useState(false);

  const industries = useMemo(() => Array.from(new Set(data.businesses.map((b) => b.industry))).sort(), [industry]);
  const cities = useMemo(() => Array.from(new Set(data.businesses.map((b) => b.city))).sort(), [city]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return data.businesses.filter((b) => {
      const matchesQ =
        !q ||
        b.name.toLowerCase().includes(q) ||
        b.industry.toLowerCase().includes(q) ||
        b.city.toLowerCase().includes(q);
      const matchesIndustry = !industry || b.industry === industry;
      const matchesCity = !city || b.city === city;
      const matchesComplete = !completeOnly || (b.typeOf4dww || "").toLowerCase().includes("complete");
      return matchesQ && matchesIndustry && matchesCity && matchesComplete;
    });
  }, [data, query, industry, city, completeOnly]);

  const sortedAlphabetically = useMemo(
    () => alphabetize(filtered, "industry", "asc"),
    [filtered]
  );
  
  return (
    <div className="directory">
      <div className="directory__inner row h-100 justify-content-center align-items-center">
        <header className="directory__header">
          <h1 className="directory__title">{data.title}</h1>
          <p className="directory__blurb">{data.blurb}</p>
        </header>

        {/* Controls */}
        <div className="directory__controls">
          <div className="ios-scale-wrap">
            <div className="control control--search">
              <input
                className="input"
                placeholder="Search name, city, industry…"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              {/* your icon can sit absolutely over this wrapper if you like */}
            </div>
          </div>

          <select
            className="select"
            value={industry || ""}
            onChange={(e) => setIndustry(e.target.value || null)}
          >
            <option value="">All industries</option>
            {industries.map((i) => <option key={i} value={i}>{i}</option>)}
          </select>

          <select
            className="select"
            value={city || ""}
            onChange={(e) => setCity(e.target.value || null)}
          >
            <option value="">All cities</option>
            {cities.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>

          {/* <label className="checkbox">
            <input
              type="checkbox"
              checked={completeOnly}
              onChange={(e) => setCompleteOnly(e.target.checked)}
            />
            <span>Show only <strong>complete 32-hour</strong></span>
          </label> */}
        </div>

        {/* Active filter pills (optional) */}
        <div className="directory__pills">
          {industry && (
            <button className="pill" onClick={() => setIndustry(null)}>
              {industry} <span className="pill__close">×</span>
            </button>
          )}
          {city && (
            <button className="pill" onClick={() => setCity(null)}>
              {city} <span className="pill__close">×</span>
            </button>
          )}
          {completeOnly && (
            <button className="pill pill--green" onClick={() => setCompleteOnly(false)}>
              Complete 32-hr only <span className="pill__close">×</span>
            </button>
          )}
        </div>

        {/* Grid */}
        <div className="directory__grid">
          {sortedAlphabetically.map((b, idx) => (
            <article key={`${b.name}-${idx}`} className="card">
              <div className="card__head">
                <h3 className="card__title">
                  {/* your lucide icon here if you want */}
                  {b.name}
                </h3>
              </div>

              <div className="card__meta">
                <span className="badge badge--industry">{b.industry}</span>
                <span className="badge badge--location">
                  {/* MapPin icon optional */}
                  {b.city}{b.state ? `, ${b.state}` : ""}
                </span>
                {b.typeOf4dww && (
                  <span>
                    {b.typeOf4dww}
                  </span>
                )}
              </div>

              <div className="card__actions">
                {b.website && (
                  <a href={b.website} target="_blank" rel="noreferrer" className="btn btn--ghost">
                    Website
                  </a>
                )}
                {b.linkedin && (
                  <a href={b.linkedin} target="_blank" rel="noreferrer" className="btn btn--ghost">
                    LinkedIn
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>

        {/* Empty state (optional) */}
        {sortedAlphabetically.length === 0 && (
          <div className="empty">
            <p>No matches found. Try clearing filters or searching a different term.</p>
            <button
              className="btn btn--primary"
              onClick={() => { setQuery(""); setIndustry(null); setCity(null); setCompleteOnly(false); }}
            >
              Reset filters
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GridLayout;